<template>
  <div class="rss-content">
    <template v-for="(rssObj,index) in rssList">
      <rss-component class="rss-component" :rss-obj="rssObj"></rss-component>
    </template>
  </div>
</template>

<script>
import RssComponent from "@/page/rss/rssComponent";
import {getRSSList, getRSSUrlList,getRSS} from "@/api/rssApi";
export default {
  name: "index",
  components: {RssComponent},
  data() {
    return {
      rssList: [],
      rssUrlList: []
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const $this = this;
      getRSSList([]).then(res =>{
        $this.rssList = res.data;
      })
      /*getRSSUrlList().then(res =>{
        $this.rssUrlList = res.data;
        $this.rssUrlList.forEach(url =>{
          $this.getRSS(url);
        })
      })*/
    },
    getRSS(url){
      const $this = this;
      getRSS({url:url}).then(res =>{
        let rssObj = res.data;
        $this.rssList.push(rssObj);
      })
    }
  }
}
</script>

<style scoped>
.rss-content {
  width: 80%;
  display: flex;
  flex-wrap: wrap;
  margin: 20px;
}

.rss-component {
  width: calc(360px - 10px); /* 减去间距以确保一行5个 */
  margin-bottom: 10px; /* 为每行底部添加一些间距 */
  margin-right: 10px;
  box-sizing: border-box; /* 确保宽度计算包括padding和border */
}

/* 为每个 .rss-component 添加左右间距 */
/*.rss-component:not(:nth-child(5n)) {
  margin-right: 10px;
}*/
</style>
